import React from "react";
import Icon from "@ant-design/icons";

const NewDashBoardIconSVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none">
    <path
      d="M22.7625 26.35C22.8869 26.4955 22.967 26.6735 22.9932 26.8631C23.0194 27.0527 22.9906 27.2458 22.9104 27.4195C22.8301 27.5932 22.7016 27.7403 22.5403 27.8432C22.3789 27.9461 22.1914 28.0005 22 28H10C9.80865 28.0005 9.62115 27.9461 9.45979 27.8432C9.29843 27.7403 9.16998 27.5932 9.0897 27.4195C9.00942 27.2458 8.98067 27.0527 9.00688 26.8631C9.03308 26.6735 9.11313 26.4955 9.23753 26.35L15.2375 19.35C15.3314 19.2394 15.4482 19.1505 15.5799 19.0896C15.7116 19.0286 15.8549 18.997 16 18.997C16.1451 18.997 16.2885 19.0286 16.4202 19.0896C16.5518 19.1505 16.6687 19.2394 16.7625 19.35L22.7625 26.35ZM26 5.00003H6.00003C5.6056 4.99837 5.21475 5.07484 4.85002 5.22502C4.4853 5.3752 4.15392 5.59611 3.87502 5.87502C3.59611 6.15392 3.3752 6.4853 3.22502 6.85002C3.07484 7.21475 2.99837 7.6056 3.00003 8.00003V22C2.99837 22.3945 3.07484 22.7853 3.22502 23.15C3.3752 23.5148 3.59611 23.8461 3.87502 24.125C4.15392 24.4039 4.4853 24.6249 4.85002 24.775C5.21475 24.9252 5.6056 25.0017 6.00003 25H7.53753C7.60876 24.9985 7.67891 24.9822 7.74347 24.9521C7.80804 24.9219 7.86562 24.8787 7.91253 24.825L13.725 18.05C14.0055 17.7205 14.3542 17.4559 14.747 17.2744C15.1398 17.0929 15.5673 16.9989 16 16.9989C16.4327 16.9989 16.8603 17.0929 17.2531 17.2744C17.6459 17.4559 17.9946 17.7205 18.275 18.05L24.0875 24.825C24.1344 24.8787 24.192 24.9219 24.2566 24.9521C24.3211 24.9822 24.3913 24.9985 24.4625 25H26C26.3945 25.0017 26.7853 24.9252 27.15 24.775C27.5148 24.6249 27.8461 24.4039 28.125 24.125C28.4039 23.8461 28.6249 23.5148 28.775 23.15C28.9252 22.7853 29.0017 22.3945 29 22V8.00003C29.0017 7.6056 28.9252 7.21475 28.775 6.85002C28.6249 6.4853 28.4039 6.15392 28.125 5.87502C27.8461 5.59611 27.5148 5.3752 27.15 5.22502C26.7853 5.07484 26.3945 4.99837 26 5.00003Z"
      fill="url(#paint0_linear_426_211)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_426_211"
        x1="16"
        y1="5"
        x2="16"
        y2="28"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7790C5" />
        <stop offset="1" stop-color="#4867AA" />
      </linearGradient>
    </defs>
  </svg>
);

const NewDashBoardIcon = (props) => (
  <Icon component={NewDashBoardIconSVG} {...props} />
);

export default NewDashBoardIcon;
